export function countByName(
  groups: { name: string; count: number }[] | undefined,
  name: string
): number | undefined {
  return groups?.find(
    (group) => group.name.toLocaleLowerCase() === name.toLocaleLowerCase()
  )?.count;
}

export function displayedCount(
  baseline: number,
  filteredCount: number | undefined,
  showTotal: boolean
): { current: number; total: number; showTotal: boolean } {
  if (!showTotal) {
    return { current: baseline, total: baseline, showTotal: false };
  }
  return {
    current: filteredCount ?? 0,
    total: baseline,
    showTotal: true,
  };
}

export function FilterCount({
  current,
  total,
  showTotal,
}: {
  current: number;
  total: number;
  showTotal: boolean;
}) {
  if (!showTotal) {
    return <span>({current})</span>;
  }
  return (
    <span>
      ({current}
      <span className="text-gray-400">{` / ${total}`}</span>)
    </span>
  );
}

export function FilterCountChip({
  current,
  total,
  showTotal,
}: {
  current: number;
  total: number;
  showTotal: boolean;
}) {
  return (
    <span className="inline-flex shrink-0 items-center whitespace-nowrap rounded-full bg-gray-100 px-1.5 py-0.5 text-xs font-medium text-gray-600">
      {showTotal ? (
        <>
          {current}
          <span className="text-gray-400">{`/${total}`}</span>
        </>
      ) : (
        current
      )}
    </span>
  );
}
